module.exports = __webpack_public_path__ + "static/media/school-background.de1889f6.jpg";